
jQuery(document).ready(function($){
  $('#account-reset .btn-primary').on('click', function() {
    $("#account-reset").validate();
});
    $('#create_customer .btn-primary').on('click', function() {
    $("#create_customer").validate();
});
    $('#recover~div form .btn-primary').on('click', function() {
    $("#recover~div form").validate();
});
  $("#ContactForm").validate();
    $('#customer_login .btn-primary').on('click', function() {
        $("#customer_login").validate({
          rules: {
            firstname: "required",
            lastname: "required",
            email: {
              required: true,
              email: true
            },
            password: {
              required: true,
              minlength: 5
            },
            password_confirmation: {
              required: true,
              minlength: 5
            }
          },

          messages: {
            firstname: "Please enter your firstname",
            lastname: "Please enter your lastname",
            password: {
              required: "Please provide a password",
              minlength: "Your password must be at least 5 characters long"
            },
            password_confirmation: {
              required: "Please provide a password",
              minlength: "Your password must be at least 5 characters long"
            },
            email: "Please enter a valid email address"
          }
       });
  	});

  jQuery('.product .sticky-bar .tab-header a:first-child').addClass('active');
  jQuery('.product .sticky-bar a').click(function(e){
      e.preventDefault();
      jQuery(this).addClass('active').siblings().removeClass('active');
      var id = jQuery(this).attr('href');
      jQuery('.tab-body-wrapper '+ id).show().siblings().hide();
      var header = jQuery('.header.header-wrapper').outerHeight();
      var stickybar = jQuery('.sticky-bar').outerHeight();
      $('html, body').animate({
          scrollTop: $(".tab-body-wrapper").offset().top - header - stickybar
      }, 1000);
  })
    jQuery('.prod-short-info .info-item .header').click(function(e){
        e.preventDefault();
      jQuery(this).addClass('active').next().slideToggle();
      jQuery(this).closest('.info-item').siblings().find('.header').removeClass('active').next().slideUp();

  })
    if($('.product section.preview-store-section.pt-40').length > 0){
      $('.product section.preview-store-section.pt-40').removeClass('pt-40');
    }
  
});